module.exports = __webpack_public_path__ + "img/round.4360ed22.svg";